module.exports = __webpack_public_path__ + "videos/vpc-video.ff7e351.mp4";